import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import $ from "jquery";
import UserContext from '../../contexts/UserContext';
import { Alert, Button, Form } from 'react-bootstrap';

const Notification = () => {
    const navigate = useNavigate();
    const {user,setUser} = useContext(UserContext);
    const [message,setMessage] = useState(null);
    const handleSubmit = async (e) => {
        e.preventDefault();
        $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/sendNotification",
            data:{title:e.target.title.value,description:e.target.description.value},
            dataType: 'json',
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
              console.log(response);
                if(response.message  && response.message.includes("Error in auth")){
                    setUser(null);
                    navigate("/login");
                  }
              if(response.message.includes("success")){
                console.log(response.message)
                setMessage(response.message);
                e.target.title.value = '';
                e.target.description.value = '';
              }    
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate("/rsvp")
            }
        })
    }

  return (
    <>
    <h5 className='text-center mt-3'>Notification Portal</h5>
    {message?<Alert className='mx-3 mt-4' key='success' variant='success' >{message} !</Alert>:null}
    <Form className='d-flex flex-column m-3' onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Title</Form.Label>
            <Form.Control type="text" name='title' placeholder="Notification Title" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Description</Form.Label>
            <Form.Control type="text" name='description' placeholder="Notification Description" />
        </Form.Group>
        <Button variant="primary" type="submit">Send Notification</Button>
    </Form>
    </>
  )
}

export default Notification